module.exports = "/images/SelectArrowWhitef.svg";